"use client";
import React, { useEffect, useState } from "react";
import TypographyMontserrat from "../../Atoms/TypographyMontserrat";

const TextRotator = ({ textArray }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [fade, setFade] = useState(false);

    useEffect(() => {
        setFade(true); // trigger initial fade in

        let timeout;

        const interval = setInterval(() => {
            setFade(false);

            timeout = setTimeout(() => {
                setCurrentIndex((prev) => (prev + 1) % textArray?.length);
                setFade(true);
            }, 500);
        }, 3000);

        return () => {
            clearInterval(interval);
            clearTimeout(timeout);
        };
    }, []);

    return (
        <div
            className={`transition-opacity duration-1000 ease-in-out will-change-opacity ${
                fade ? "opacity-100" : "opacity-0"
            }`}
        >
            <TypographyMontserrat
                customStyle={"text-center text-[13px] sm:text-sm"}
                fontWeight="medium"
                text={textArray?.[currentIndex]}
            />
        </div>
    );
};

export default TextRotator;
